/**
 * custom-mega-menu-multi.js  (feature: nav-restructure — CRO #1–3)
 *
 * Flex's storefront init reliably attaches only the FIRST mega-menu section in
 * the header; additional mega-menu sections (we run three: Shop Collections /
 * Shop by Colors / Shop by Rooms) don't get wired to their nav item, so their
 * dropdown falls back to the native menu instead of the multi-column mega menu.
 *
 * This re-runs the theme's OWN init (window.PXUTheme.jsMegaMenu.init) for every
 * mega-menu section after load, using the theme's public API — it does not
 * modify any compiled/base file. init() is idempotent (it removes an existing
 * clone from the parent before re-appending), so re-initialising the already-
 * attached first menu is harmless.
 *
 * Loaded from sections/header-classic.liquid, after z__jsHeader.js.
 */
(function () {
  function attachAllMegaMenus() {
    var pxu = window.PXUTheme;
    var $ = window.jQuery;
    if (!$ || !pxu || !pxu.jsMegaMenu || typeof pxu.jsMegaMenu.init !== 'function') {
      return;
    }

    $('.shopify-section.jsMegaMenu').each(function () {
      pxu.jsMegaMenu.init($(this));
    });
  }

  // Run after the theme's own window-load handler has finished wiring sections.
  if (document.readyState === 'complete') {
    window.setTimeout(attachAllMegaMenus, 0);
  } else {
    window.addEventListener('load', function () {
      window.setTimeout(attachAllMegaMenus, 0);
    });
  }
})();
